import { GenSnackBar } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { ApiErrorDataTokens, StatusCode } from '../../../common/enums/enums';

const SnackBarType = {
  SUCCESS: 'success',
  ERROR: 'error',
};

const getSnackBarType = statusCode => {
  switch (statusCode) {
    case StatusCode.SUCCESS:
      return SnackBarType.SUCCESS;
    case StatusCode.BAD_REQUEST:
      return SnackBarType.ERROR;
    default:
      return SnackBarType.ERROR;
  }
};

export default function DeleteServiceStatus({
  open,
  deleteModalStatus,
  onClose,
}) {
  const { t } = useTranslation('orders');
  const snackBarType = getSnackBarType(deleteModalStatus?.status);
  let title = '';
  let message = '';

  if (deleteModalStatus?.status === StatusCode.SUCCESS) {
    message = t('wOrderServicesDeletePopUp.success');
  }

  if (
    deleteModalStatus?.status === StatusCode.BAD_REQUEST &&
    deleteModalStatus?.token === ApiErrorDataTokens.CANT_CANCEL_ALL_SERVICES
  ) {
    title = t('wOrderServicesDeletePopUp.lastServiceError.title');
    message = t('wOrderServicesDeletePopUp.lastServiceError.message');
  }

  if (
    deleteModalStatus?.status === StatusCode.BAD_REQUEST &&
    deleteModalStatus?.token === null
  ) {
    message = t('wOrderServicesDeletePopUp.genError');
  }

  return (
    <GenSnackBar
      open={open}
      message={message}
      type={snackBarType}
      onClose={onClose}
      title={title}
    />
  );
}
